import { Board } from '~/components/Shared/Layout/Board/Board';
import { UserPromotionFormTable } from './UserPromotionFormTable/UserPromotionFormTable';
import styles from './UserPromotionFormBoard.module.scss';
import { useTranslation } from 'react-i18next';
import dayjs, { Dayjs } from 'dayjs';
import { Pagination, Spinner } from '~/ui';
import { TableSelect } from '~/ui/TableSelect/TableSelect';
import { TableAmountPage } from '~/ui/TableAmountPage/TableAmountPage';
import { CustomDatePicker } from '~/components/Shared/CustomDatePicker/CustomDatePicker';

const DEFAULT_DATES: [Dayjs, Dayjs] = [dayjs().subtract(6, 'month'), dayjs()];

interface IPromotionItem {
  points: number;
  created_at: string;
  promo_loyalty: { id: number; name: string } | null;
  manual_action: boolean | null;
  food_order_id: number | null;
  by_user: {
    full_name: string;
    id: number;
  };
  order_info: {
    food_order_id: number | null;
    id: number | null;
    type: string | null;
  };
}

interface IPagination {
  from: number;
  to: number;
  total: number;
  lastPage: number;
}

interface IUserPromotionProps {
  dates: [Dayjs, Dayjs];
  data: IPromotionItem[];
  pagination: IPagination;
  setDates: (dates: [Dayjs, Dayjs]) => void;
  isLoading: boolean;
  sort: { field: string; direction: string };
  setSort: ({ field, direction }: { field: string; direction: string }) => void;
  page: number;
  setPage: (page: number) => void;
  perPage: number;
  setPerPage: (perPage: number) => void;
}

export const UserPromotionFormBoard = ({
  data,
  pagination,
  isLoading,
  dates,
  setDates,
  sort,
  setSort,
  page,
  setPage,
  perPage,
  setPerPage,
}: IUserPromotionProps) => {
  const { t } = useTranslation();

  return (
    <Board classNames={styles.board}>
      <div className={styles.filtersWrapper}>
        <TableSelect perPage={perPage} setPerPage={setPerPage} />
        <CustomDatePicker
          value={dates}
          disabled={isLoading}
          showPresets={true}
          placeholder={[t('date_validate'), t('date_validate')]}
          onDatesChange={newDates => {
            setDates(newDates || DEFAULT_DATES);
          }}
        />
      </div>
      {Array.isArray(data) && !isLoading ? (
        <UserPromotionFormTable data={data} sort={sort} setSort={setSort} />
      ) : (
        <Spinner />
      )}
      {pagination && (
        <div className={styles.paginationWrapper}>
          <TableAmountPage
            firstRow={pagination.from}
            lastRow={pagination.to}
            total={pagination.total}
          />
          <Pagination
            pageCount={pagination.lastPage}
            forcePage={page}
            onPageChange={({ selected }: { selected: number }) =>
              setPage(selected + 1)
            }
          />
        </div>
      )}
    </Board>
  );
};
